import type { Permission } from '@tempo-io/permissions';
import { usePermissions } from './usePermissions';

export const usePermission = (permission: Permission): boolean =>
  usePermissions([permission])[permission];
